
define('modules/application/widgets/automationConsumptionIndicator',[
  "app",

  // Libs
  "backbone",

  //Classes
  "../header",

  "./consumptionIndicator"

],

function(app, Backbone, Header, consumptionIndicator) {

  var automationConsumptionIndicatorModel= consumptionIndicator.Model.extend({
    recalculatePercentages : function() {
      consumptionIndicator.Model.prototype.recalculatePercentages.apply(this);
      BticinoS4B.Instances.Models.ApplicationModel.set("percentageOfTotalCurrentConsumption", percentageOfTotalCurrentConsumption);
    }
  });

  var automationConsumptionIndicatorView = consumptionIndicator.View.extend({
    className  : "consumptionIndicator",
    template   : "application/widgets/consumptionIndicator",
    initialize : function() {
      consumptionIndicator.View.prototype.initialize.apply(this);
      this.fullWidth = 125;
    }
  });

  var automationConsumptionIndicator = {
    Model: automationConsumptionIndicatorModel,
    View : automationConsumptionIndicatorView
  };

  return automationConsumptionIndicator;

});